import { TaxonomyEnum } from '.codegen/generatedApi'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppThunkOptions } from 'app/store'
import { WP_POST_TYPE_NAME } from 'config'
import { asTaxonomyEnum } from 'helpers'
import { batch } from 'react-redux'
import { QueriedObject, QueriedObjectType, TaxonomyId, TermSearchPayload, TermSelectPayload, TermSelectPayloadReset } from 'types'
import { pageChanged } from './results/resultsSlice'
import { searchSubmit } from './search/searchSlice'
import { selectIncludedCountries } from './selectors'
import api from './services/api'

/**
 * Initial Loading
 */
export const initSettings = createAsyncThunk<boolean, void, AppThunkOptions>('search/initSettings', (_, { dispatch }) => {
  batch(() => {
    dispatch(showTerms(TaxonomyEnum.Productcategory))
    dispatch(showTerms(TaxonomyEnum.Brand))
    dispatch(showTerms(TaxonomyEnum.Stockist))
    dispatch(showTerms(TaxonomyEnum.Producingcountry))
    dispatch(api.endpoints.settings.initiate({ postTypeName: WP_POST_TYPE_NAME }))
  })
  return true
})

export const objectQueried = createAsyncThunk<boolean, QueriedObject | null, AppThunkOptions>(
  'search/objectQueried',
  (queriedObject, { dispatch }) => {
    if (queriedObject?.type === QueriedObjectType.TERM) {
      dispatch(
        termNavClicked({
          termId: queriedObject.id.id,
          taxonomyId: queriedObject.id.taxonomyId,
          reset: true,
        })
      )
    }

    return true
  }
)

/**
 * Handles term loading api calls
 */
export const showTerms = createAsyncThunk<boolean, TaxonomyId, AppThunkOptions>(
  'taxonomy/showTerms',
  (taxonomyId, { dispatch, getState }) => {
    const taxonomy = asTaxonomyEnum(taxonomyId)

    const args = {
      taxonomy,
      include: [] as string[],
    }

    if (taxonomyId === 'COUNTRY') {
      const countries = selectIncludedCountries(getState())
      args.include = countries.map((v) => `${v}`)
    }

    dispatch(api.endpoints.getTerms.initiate(args))

    return true
  }
)

/**
 *
 */
export const termSearchChanged = createAsyncThunk<boolean, TermSearchPayload, AppThunkOptions>(
  'taxonomy/termSearchChanged',
  (payload, { dispatch }) => {
    return true
  }
)

/**
 *
 */
export const filterTermSelected = createAsyncThunk<boolean, TermSelectPayloadReset, AppThunkOptions>(
  'taxonomy/filterTermSelected',
  (payload, { dispatch }) => {
    batch(() => {
      /* Reset the page to 1 when filtering */
      if (payload.reset) dispatch(pageChanged(1))
      dispatch(selectionChanged(payload))
    })
    return true
  }
)

/**
 *
 */
export const termNavClicked = createAsyncThunk<boolean, Omit<TermSelectPayloadReset, 'checked'>, AppThunkOptions>(
  'taxonomy/termNavClicked',
  (payload, { dispatch }) => {
    batch(() => {
      /* Reset the page to 1 when filtering */
      dispatch(clearFilters())
      dispatch(filterTermSelected({ ...payload, checked: true }))
    })
    return true
  }
)

/**
 * Used only by `taxSlice` `extraReducers` to update selection state
 */
export const selectionChanged = createAsyncThunk<boolean, TermSelectPayload, AppThunkOptions>(
  'taxonomy/selectionChanged',
  (_, { dispatch }) => {
    return true
  }
)

/**
 *
 */
export const searchFormSubmitted = createAsyncThunk<boolean, string, AppThunkOptions>(
  'search/submitted',
  async (searchQuery, { dispatch }) => {
    await batch(async () => {
      /* Reset the page to 1 when searching */
      await dispatch(pageChanged(1))
      await dispatch(searchSubmit({search: searchQuery, type: 'brands'}))
    })
    return true
  }
)

/**
 * Used only by `taxSlice` and `searchSlice` `extraReducers` to update selection state
 */
export const clearFilters = createAsyncThunk<void, void, AppThunkOptions>('search/clearFilters', (_, thunkAPI) => {})

/**
 *
 */
export const singleProductView = createAsyncThunk<boolean, string, AppThunkOptions>('results/singleProduct', async (slug, { dispatch }) => {
  await dispatch(api.endpoints.getProduct.initiate({ slug }))
  return true
})